import type {ISelectData} from '@/components/select';
import {Select} from '@/components/select';

interface TOptions {
    onToggle(type: string): void;
    onChangeSort(data: ISelectData): void;

}

class CardsHead {
    public currSort: ISelectData;
    private readonly searchedCountEl: HTMLElement | null;

    constructor(parent: HTMLElement, options?: TOptions) {
        if (!parent) {
            console.warn(`Parent is ${parent}`);

            return;
        }

        const selectEl = parent.querySelector('.cards-head__select') as HTMLElement;
        const toggleViewEl = parent.querySelector('.cards-head__view-toggle');

        this.searchedCountEl = parent.querySelector('.cards-head__searched-count');

        if (selectEl) {
            // eslint-disable-next-line no-new
            new Select(selectEl, {
                onChange: (data) => {
                    this.currSort = data;
                    if (typeof options?.onChangeSort === 'function') {
                        options.onChangeSort(data);
                    }
                },
                onInit: (data) => {
                    this.currSort = data;
                }
            });
        }

        if (toggleViewEl && typeof options?.onToggle === 'function') {
            toggleViewEl.addEventListener('input', (ev) => {
                options.onToggle((ev.target as HTMLInputElement).value);
            });
        }
    }

    updateSearchedCount(num: number, quantity: number): void {
        if (this.searchedCountEl?.innerHTML) {
            this.searchedCountEl.innerHTML =
            `${num === 1 ? 'Найдена 1 квартира' : `Найдено квартир: ${quantity} из ${num}`} `;
        }
    }
}

export default CardsHead;
